import React, { Component } from 'react';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
import Image from '../../../../../../components/ZUILib/Image';
import commonUtil from '../../../../../../utils/commonUtil';
import * as giftListActions from '../../actions';
import serverClientUtil from '../../../../../../utils/serverClientUtil';
import * as defaultConst from '../../../../../../utils/clientConstant';
import Favourite from '../../../../../../components/ZUILib/Favourite';

const predefinedStatus = defaultConst.RESTRICTED_EVENT_STATUSES;
const { setFavouriteGift } = giftListActions;
class Template1 extends Component {
  constructor(props) {
    super(props);
    this.addressName = '';
  }

  setFavouriteGiftItem = (e, item, handleChange) => {
    setFavouriteGift(this.props.eventId, item.giftItemId, item.skuId, (!item.isFavourite).toString()).then((response) => {
      if (response.body.status.status === 'success') {
        this.props.handleBulkAction(response, 'favourite', (!item.isFavourite), item.giftItemId);
         this.props.handleSortAndFilter({ priceOrder: 'Ascending' })

        if (handleChange) {
          handleChange();
        }
      }
    }).catch((err) => { console.log(err); }); // console required
  }

  showButtons = (checkedID, giftDetail, status) => {
    this.props.selectedItem(giftDetail, status);
  }
  hideAndReset = () => {
    document.querySelector('#footerBarOptionsRegisteredGifts').style.display = 'none';
  }


  isNotEmpty = obj => obj !== undefined && JSON.stringify(obj) !== JSON.stringify({})
  render() {
    const { giftDetail, categoryName } = this.props;

    const lables = this.props.lables;
    const giftImageSrc = [
      {
        media: '(max-width: 465px)',
        srcSet: giftDetail.imageURL,
      },
    ];
    if (categoryName === 'Gift Certificate' || categoryName === 'Certificado Electrónico') {
      this.defaultImage = commonUtil.getAssetURL() + '/images/certificado.jpg';
    } else {
      this.defaultImage = commonUtil.getAssetURL() + '/images/guest/no-image.png';
    }
    const giftImageAttribute = {
      id: 'img01',
      alt: 'Liverpool',
      src: giftDetail.imageURL, // TODO: Need to upload all images in static asset
      altImg: giftDetail?.altImageUrl || this.defaultImage,
      width: '90',
      pictureHtmlStyle:{
        flexPicture:'flex'
      }
    };
    
    const isSalePriceLessThanListPrice = giftDetail.salePrice && giftDetail.listPrice && (parseFloat(giftDetail.salePrice) < parseFloat(giftDetail.listPrice));
    const salePrice = giftDetail.salePrice ? commonUtil.getCurrency(giftDetail.salePrice , true) : null;
    const listPrice = giftDetail.listPrice ? commonUtil.getCurrency(giftDetail.listPrice , true) : null;
    const [salePriceWhole, salePricecents] = salePrice?.split('.') ?? ['', ''];
    const salePriceFormatted = (
      <>
        {salePriceWhole}<sup>{salePricecents}</sup>
      </>
    );
    const isDisabled = (this.props.compareEventStatus(this.props.eventStatus, predefinedStatus));
    let deliverAddressNickName = '';
    if (!commonUtil.isObjectEmpty(this.props.deliveryAddressInfo)) {
      this.props.deliveryAddressInfo.forEach((p1) => {
        if (p1.deliveryAddressId === giftDetail.addressId) {
          deliverAddressNickName = p1.deliveryAddressName;
        }
      });
    }
    const giftListPrice = commonUtil.getCurrency(giftDetail.listPrice , true);
    const [giftListPriceWhole, giftListPricecents] = giftListPrice?.split('.') ?? ['', ''];
    const [currencySymbol, priceValue] = giftListPriceWhole.split(' ').map(part => part.trim());
    const giftListPriceFormattedStrikeThrough = (
      <>
        <span className="textListPriceBefore pr-3">{currencySymbol}</span><span className="textListPriceBefore pr-3">{priceValue}</span><sup className="textListPriceBefore priceBefore fs-8">{giftListPricecents}</sup>
      </>
    );
    const giftListPriceFormatted = (
      <>
        {giftListPriceWhole}<sup>{giftListPricecents}</sup>
      </>
    );
    return (

      <tr>
        {this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.VALIDITY_OFF_ACTIVE) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.CLOSED) ? 
          <td className="selectRegister"></td>
        :
        <td className="selectRegister">
          <CheckBox
            id={'selectGift' + giftDetail.giftItemId}
            name="check"
            checked={this.props.selectedThisItem}
            getSelectedValue={(e) => { this.showButtons(('check_' + giftDetail.giftItemId), giftDetail, e.checked); }}
            disabled={isDisabled}
          />
        </td>
        }

        <td className={`${giftDetail.availability ? '' : ''} imgInner imginner-align-met`}>
          {(categoryName === 'Gift Certificate' || categoryName === 'Certificado Electrónico') ?
            <Image imageAttr={giftImageAttribute} _imgsrc={giftImageSrc} /> :
            <React.Fragment>
              {(giftDetail.catalogRedirectionURL && (this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.VALIDITY_OFF_ACTIVE) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.ACTIVE))) ? 
              <a href={serverClientUtil.getLPURL() + giftDetail.catalogRedirectionURL} target="_blank" rel="noopener noreferrer">
                {
                  giftDetail.availability ?
                    <Image imageAttr={giftImageAttribute} _imgsrc={giftImageSrc} />
                    :
                    <div className="item-notAvailable">
                      <Image imageAttr={giftImageAttribute} _imgsrc={giftImageSrc} />
                      <span>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.notAvailable')}</span>
                    </div>
                }
              </a> :
                <React.Fragment>
                  {
                    giftDetail.availability ?
                      <Image imageAttr={giftImageAttribute} _imgsrc={giftImageSrc} />
                      :
                      <div className="item-notAvailable">
                        <Image imageAttr={giftImageAttribute} _imgsrc={giftImageSrc} />
                        <span>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.notAvailable')}</span>
                      </div>
                  }
                </React.Fragment>
              }
            </React.Fragment>}

        </td>
        <td className="p-l-10"><span className="headTitle">{giftDetail.desc}</span>
          <span className="textCategory">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.sku.label')}:<span className="sku">{giftDetail.skuId}</span>
          </span>
          {isSalePriceLessThanListPrice ?
            <React.Fragment>
              <span className="price"><span className='d-flex'>{giftListPriceFormattedStrikeThrough}</span> {salePriceFormatted}</span>
            </React.Fragment>
          :
            <span className="price">{giftListPriceFormatted}</span>
          }
          {/* <span className="disponibility">
            {giftDetail.availability === 'true' ?
              <React.Fragment>
                <div className="textGreen">{commonUtil.getLabel(lables.RegalosRegistradosPage, 'regalosregistrados.inventory.displonsible.label')}&nbsp;&nbsp;
                  <i className="icon-flecha_light_abajo tooltip-container">
                    <div className="detailText tooltip-box">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.available.tooltip')}
                    </div></i>
                </div>
              </React.Fragment>
              :
              <React.Fragment><div className="textRed">{commonUtil.getLabel(lables.RegalosRegistradosPage, 'regalosregistrados.inventory.nodisplonsible.label')}&nbsp;&nbsp;
                <i className="icon-flecha_light_abajo tooltip-container">
                  <div className="detailText tooltip-box">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.available.online.tooltip')}
                  </div> </i>
              </div>
              </React.Fragment>}
          </span> */}

          {
            this.props.compareEventStatus(giftDetail.deliveryMode, defaultConst.constGiftDeliveryMode.Físicos) ? (
              <span className="modeGift">
                <i className="icon-home"></i>
                {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.wap.label')}
              </span>
            ) : (
              <span className="modeGift">
                <i className="icon-monetization_on"></i>
                {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.wap.label')}
              </span>
            )
          }
          

        </td>
        {(this.props.compareEventStatus(this.props.eventStatus, predefinedStatus)) ?
          <td>
            <i className="iconRight icon-flecha_lightsvg_derecha" aria-hidden="true" />
          </td> :
          <td>
            {/* giftSetting */}
            <div className="contentFavGift">
                <Favourite
                  id={giftDetail.skuId}
                  item={giftDetail}
                  checked={giftDetail.isFavourite}
                  onchange={e => this.setFavouriteGiftItem(e, giftDetail)}
                  channel="WAP"
                // tooltipData={<span className="tooltip-box w2 text-align-center">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.favorite.tooltip')}</span>}
                />
              </div>
              {
                 isDisabled ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none" 
                    className="iconRight icon-flecha_lightsvg_derecha icon-right-pos-marg-add-svg-drecha">
                    <path d="M1.70492 0.5L0.294922 1.91L4.87492 6.5L0.294922 11.09L1.70492 12.5L7.70492 6.5L1.70492 0.5Z" fill="#767676" />
                  </svg>
                 ):
                 (
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none" onClick={() => this.props.showUpdateGiftDetailsModalWithProductData(giftDetail)}
                    className="iconRight icon-flecha_lightsvg_derecha icon-right-pos-marg-add-svg-drecha">
                    <path d="M1.70492 0.5L0.294922 1.91L4.87492 6.5L0.294922 11.09L1.70492 12.5L7.70492 6.5L1.70492 0.5Z" fill="#767676" />
                  </svg>
                 )
              }
            
          </td> }

      </tr>


    );
  }
}

export default Template1;
